import { render, staticRenderFns } from "./AtomAce.vue?vue&type=template&id=b48d3d96&scoped=true&"
import script from "./AtomAce.vue?vue&type=script&lang=ts&"
export * from "./AtomAce.vue?vue&type=script&lang=ts&"
import style0 from "./AtomAce.vue?vue&type=style&index=0&id=b48d3d96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48d3d96",
  null
  
)

export default component.exports